var map = {
	"./mountain-badge--dark.svg": 953,
	"./mountain-badge--light.svg": 954,
	"./snow-badge--dark.svg": 955,
	"./snow-badge--light.svg": 956,
	"./tide-badge--dark.svg": 957,
	"./tide-badge--light.svg": 958,
	"./weather-badge--dark.svg": 959,
	"./weather-badge--light.svg": 960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 952;